import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ISkillBlock, ISkillBlockResource } from "../types";

export interface ISkillBlockQueryParameters {
    skillBlock?: RelationalValue<ISkillBlockResource>;
}

export type ISkillBlockQueryResult = ISkillBlock;

export const skillBlockQuery: IApiQueryFunction<ISkillBlockQueryParameters> = ({ skillBlock }) => {
    if (!skillBlock) {
        return;
    }

    return {
        method: "GET",
        url: `/skill_blocks/${mapRelationalValue(skillBlock)}`,
    };
};

export const useSkillBlockQuery = createApiQueryHook<ISkillBlockQueryParameters, ISkillBlockQueryResult>(
    skillBlockQuery,
);
